import { useState, useCallback, useEffect } from "react";
import darkTheme from "../themes/dark-theme";
import lightTheme from "../themes/light-theme";
import { useSelector } from "react-redux";
import { RematchRootState } from "@rematch/core";
import { KoreModel } from "../../rematch/models";
import { Theme } from "@mui/material/styles";
import { frFR, enUS } from "@mui/material/locale";

const useKomutelTheme = (locale: string): [Theme, string] => {
  const muiLocale = locale === "fr" ? frFR : enUS;

  const [theme, setTheme] = useState(lightTheme(false));
  const [logo, setLogo] = useState("");
  const desktopConfigs = useSelector((state: RematchRootState<KoreModel>) => state.desktopConfigs);

  const toggleTheme = useCallback(() => {
    if (desktopConfigs.theme) {
      let newTheme: Theme;

      if (desktopConfigs.theme === "dark") {
        setLogo("koreBlanc.png");
        newTheme = darkTheme(desktopConfigs.dense, muiLocale);
      } else {
        setLogo("kore.png");
        newTheme = lightTheme(desktopConfigs.dense, muiLocale);
      }

      setTheme(newTheme);
    }
  }, [desktopConfigs.dense, desktopConfigs.theme, muiLocale]);

  useEffect(() => toggleTheme(), [desktopConfigs.theme, desktopConfigs.dense, toggleTheme]);

  return [theme, logo];
};

export default useKomutelTheme;
